import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import { Tabs, Tab, MenuItem, Menu, Divider, Drawer, Dialog } from '@mui/material';
import Typography from '@mui/material/Typography';
import iconTest from '../images/others/icon.svg';
import newClients from '../images/tabs/newClients.png';
import myClients from '../images/tabs/myClients.png';
import moveProducts from '../images/tabs/moveProducts.png';
import saveProducts from '../images/tabs/saveProducts.png';
import warehouseIcon from '@mui/icons-material/Warehouse';
import pickProducts from '../images/tabs/pickProducts.png';
import createDelivery from '../images/tabs/createDelivery.png';
import storageProducts from '../images/tabs/storageProduct.png';
import myProduct from '../images/tabs/myProduct.png';
import points from '../images/header/points.png';
import transfer from '../images/tabs/transfer.png';
import chat from '../images/header/chat.png';
import help from '../images/header/help.png';
import avatarTest from '../images/others/avatar.png';
import Tooltip from '@mui/material/Tooltip';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import { clearState, loginSelector } from '../store/slices/loginSlice';
import { useSelector, useDispatch } from "react-redux";
import { getDataSource } from '../api/ds';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
//import { onChange } from '../store/slices/fbs-fbo';
import { colors } from '../styles/colors';
import { onChangeEditWidjets } from 'store/slices/editWidjets';
import { onChangeCompanyClient } from 'store/slices/companyClient';
import CompanyClient from 'components/companyClient';
import { SelectMarket } from 'components/SelectMarket';
import { ElementInfo, useAdaptiveTabsFont } from 'components/ElementInfo';
import { get, getFile } from 'api/apiBridges/httpBridge';
import UserAvatar from 'components/EIComponents/UserAvatar';
import Loading from 'components/Load';
import useOn from 'components/socketLib/UseOn';
import { MarketClientSelector } from 'store/slices/marketClient';
import Cookies from 'js-cookie';
import Checkbox from '@mui/material/Checkbox';
import { ShowModal } from "components/Modal";
import { NewClientDialog } from 'utils/dndutils/toppanelformatters';
import Scrollbars from 'rc-scrollbars';
import { seamlesAuth } from '../store/slices/loginSlice';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { setTab, clearTab, selectCurrentTab } from 'store/slices/tabSlice';
import GlobalSearch from 'components/GlobalSearch';
import { hoverStyle } from "styles/main";

const HEADERTab = styled(Tab)(({ theme }) => ({
    alignItems: "center",
    textTransform: "none",
    color: "#808080",
    transition: "all 0.2s ease-in-out",
    fontSize: "20px",
    fontWeight: 'normal',
    
    // Способ 1: Уменьшение высоты через minHeight
    minHeight: '30px', // вместо стандартных 48px
    height: "30px",
    
    // Способ 2: Уменьшение отступов внутри компонента
    // padding: '12px 20px', // вместо стандартных 12px 16px
    marginLeft: "10px",
    marginRight: "10px",

    
    // Способ 3: Уменьшение высоты строки
    lineHeight: 1.2,

    "&.Mui-selected": {
        color: "#078376",
        fontWeight: 'bold',
    },
}));

// для отображения иконки к вкладке
const IconTab = ({ img }) => {
    switch (img) {
        case 'newClients':
            return (
                <>
                    <img src={newClients} style={{ height: '28px', marginRight: '2px' }} ></img>
                </>
            );
        case 'myClients':
            return (
                <>
                    <img src={myClients} style={{ height: '28px', marginRight: '2px' }} ></img>
                </>
            );
        case 'pickProducts':
            return (
                <>
                    <img src={pickProducts} style={{ height: '28px', marginRight: '2px' }} ></img>
                </>
            );
        case 'moveProducts':
            return (
                <>
                    <img src={moveProducts} style={{ height: '28px', marginRight: '2px' }} ></img>
                </>
            );
        case 'saveProducts':
            return (
                <>
                    <img src={saveProducts} style={{ height: '28px', marginRight: '2px' }} ></img>
                </>
            );
        case 'transfer':
            return (
                <>
                    <img src={transfer} style={{ height: '28px', marginRight: '2px' }} ></img>
                </>
            );
        case 'createDelivery':
            return (
                <>
                    <img src={createDelivery} style={{ height: '28px', marginRight: '2px' }} ></img>
                </>
            );
        case 'storageProducts':
            return (
                <>
                    <img src={storageProducts} style={{ height: '28px', marginRight: '2px' }} ></img>
                </>
            );
        case 'myProduct':
            return (
                <>
                    <img src={myProduct} style={{ height: '28px', marginRight: '2px' }} ></img>
                </>
            );
        default:
            return (
                <>
                    <img src={iconTest} style={{ height: '28px', marginRight: '2px' }} ></img>
                </>
            );
    }
}

// тестовые данные
const comps = [
    { name: 'Ип Иванова', inn: '123421113' },
    { name: 'ООО Иванова', inn: '98765431' },
    { name: 'ОАО Иванова', inn: '12345671' }
]

// заголовок
function MainHeader() {
    const navigate = useNavigate();// хук для навигации между маршрутами
    const location = useLocation();// текущий маршрут (используется для проверки активной страницы)
    const { user_id, role, rules } = useSelector(loginSelector);// получаем роль текущего пользователя из Redux
    const ds = useMemo(() => getDataSource(role), []); // получаем дескриптор
    const tab = useSelector(selectCurrentTab);// текущая активная вкладка
    const dispatch = useDispatch();// dispatch для отправки действий в Redux
    const [ userPhoto, setUserPhoto] = useState(undefined);
    const [ user, setUser] = useState(undefined);
    const [ openSearch, setOpenSearch] = useState(false);

    const [anchorSettings, setAnchorSettings] = useState(false);// якорь для выпадающего меню настроек
    const [openSettings, setOpenSettings] = useState(false)

    const [openLogoutDialog, setOpenLogoutDialog] = useState(false);
    const [dontAskAgain, setDontAskAgain] = useState(
        Cookies.get('skipLogoutConfirm') === 'true'
    );
    const [skipLogoutConfirm, setSkipLogoutConfirm] = useState(
        Cookies.get('skipLogoutConfirm') === 'true'
    );

    const { containerRef } = useAdaptiveTabsFont({ min: 12, max: 40, ratio: 0.04 });

    // useEffect(() => {
    //     // если пользовтель - клиент, то установить поля в Redux
    //     if (ds.descr.id === 'client') {
    //         dispatch(onChangeCompanyClient({ name: comps[0].name, inn: comps[0].inn }));
    //     }
    // }, [ds]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                let responseData = undefined
                switch (role) {
                    case "client":
                        responseData = await get('Clients/get', {cid:user_id});
                        break;
                    case "admin":
                        responseData = await get('Admins/get', {aid:user_id});
                        break;
                    case "manager":
                        responseData = await get('Managers/get', {mid:user_id});
                        break;
                }
                if (responseData?.message) {
                    setUser(responseData.message)
                    let photo = undefined
                    if (responseData.message.data) {
                        let userData = JSON.parse(responseData.message.data)
                        photo = userData?.photo
                    }
                    setUserPhoto(photo)
                }
            } catch (err) {
            }
            };
    
    
        fetchData();
      }, [user_id]); 


    const openAllSettings = Boolean(anchorSettings);// открыт ли Popover настроек
    const idSettings = openAllSettings ? 'simple-popover' : undefined;

    

    //Функции для открытия и закрытия настроек
    const openMenuSettigs = (event) => {
        setAnchorSettings(event.currentTarget);
    }

    const handleCloseSettings = () => {
        setAnchorSettings(null);
    };

    const handleClose = () => {
        setOpenSettings(false)
    };

    // смена вкладки
    const handleChange = (event, newTab) => {
        console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!-")
        navigate(newTab);// переход по id вкладки
        dispatch(setTab(newTab))
        localStorage.setItem("TAB", newTab)
    };

    // переход на дашборды страницу
    const homeClick = () => {
        navigate('home');
        dispatch(clearTab())// сбрасываем текущую вкладку
        localStorage.removeItem('TAB');
    }

    //Переключение между режимами FBS и FBO
    // const handleChangeSwitch = (event) => {
    //     if (!event.target.checked) {
    //         dispatch(onChange({ fbs: true, fbo: false }));
    //     } else {
    //         dispatch(onChange({ fbs: false, fbo: true }));
    //     }
    // };

    // вкл/выкл редактирование виджетов
    const handleChangeSwitchEditWidjets = (event) => {
        if (!event.target.checked) {
            dispatch(onChangeEditWidjets({ editWidjets: true }));
        } else {
            dispatch(onChangeEditWidjets({ editWidjets: false }));
        }

    };

    //Обработка выбора в меню настроек
    const handleSettirngsOpen = (idWindow) => {
        navigate(idWindow);// переход на страницу по id
        setAnchorSettings(null);// закрываем Popover
        dispatch(clearTab())// сбрасываем вкладку
        localStorage.removeItem('TAB');
    };

    //Выход из аккаунта
    const doLogout = useCallback(() => {
        dispatch(clearState());
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('user_id');
        localStorage.removeItem('sub_id');
        localStorage.removeItem('role');
        localStorage.removeItem('TAB');
        localStorage.removeItem('market');
        navigate('/login');
    }, [dispatch, navigate]);

        // Функция, вызываемая при клике "Выйти"
    const handleLogoutClick = () => {
        if (skipLogoutConfirm) {
            doLogout(); // сразу выходим, если куки стоят
            return;
        }

        let localChecked = false; // состояние галочки внутри модалки

        ShowModal(
            'Подтверждение выхода',
            <div>
            <div style={{ marginBottom: '10px' }}>Вы действительно хотите выйти?</div>
            <label style={{ cursor: 'pointer' }}>
                <input
                type="checkbox"
                defaultChecked={false}
                onChange={(e) => {
                    localChecked = e.target.checked;
                }}
                style={{ marginRight: '8px', accentColor:'#158174',width: '16px',height: '16px', }}
                />
                Больше не спрашивать
            </label>
            </div>,
            () => {
            // Сохраняем выбор пользователя в куки
            if (localChecked) {
                Cookies.set('skipLogoutConfirm', 'true', { expires: 365 });
                setSkipLogoutConfirm(true); // обновляем state
            }
            doLogout(); // выходим
            }
        );
    };

    const handleCancelLogout = () => {
        setOpenLogoutDialog(false);
    };

    const checkRole = (id) => {
        
        if (rules.includes("admin")) {
            return true    
        }
        switch (id) {
            case 'newClients':
                return rules.includes("main.new_clients")
            case 'myClients':
                return rules.includes("main.my_clients")
            case 'pickProducts':
                return rules.includes("main.pick_product")
            case 'moveProducts':
                return rules.includes("main.move_product")
            case 'storageProducts':
                return rules.includes("main.storage_product")
            case 'transfer':
                return rules.includes("main.shipment_product")
            case 'saveProducts':
                return rules.includes("main.addr_storage")
            case 'myProduct':
                return rules.includes("client.main.my_products")
            case 'createDelivery':
                return rules.includes("client.main.delivery")
            case 'ClientProductStorage':
                return rules.includes("client.main.storage")
            case 'myConsumables':
                return rules.includes("client.main.consumabels")
            default:
                return true
        }
    }
    
    const adminMenuCheckRole = (tab) => {
        if (rules.includes("admin")) {
            return true    
        }
        switch(tab){
            case "company":
                return rules.includes("settings.company")
            case "handbook":
                return rules.includes("settings.handbook")
        }
    }

    const clientMenuCheckRole = (tab) => {
        if (rules.includes("admin")) {
            return true    
        }
        switch(tab){
            case "company":
                return rules.includes("settings.company")
            case "handbook":
                return rules.includes("settings.handbook")
        }
    }



    // Состояние модального окна
    const [open, setOpen] = useState(false);
    
    // Обработчики состояния модального окна
    const DialoghandleClickOpen = () => {
      setOpen(true);
    };

    const DialoghandleClose = () => {
      setOpen(false);
    };

    const [state, setState] = useState({
        right: false,
        id: 0
      });

    const eids = getDataSource(ds.descr.EIDS)
    const [unsavedChanges, setUnsavedChanges] = useState(false);
    
    const toggleDrawer = (anchor, open, idcard, defaultTab = undefined, mg = false) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        
        const performToggle = () => {
            if (defaultTab) {
            eids.descr.defaultTab = defaultTab;
            }
            
            if (!mg) {
            eids.descr.tabs = eids.descr.tabs.filter((fel) => fel !== 'moveGuide');
            } else {
            if (!eids.descr.tabs.includes("moveGuide")) {
                eids.descr.tabs.push('moveGuide');
            }
            }
            const finalId = !open ? null : idcard;
            setUnsavedChanges(false); 
            
            // @ts-ignore
            setState({ [anchor]: open, id: finalId });
        };

        if (!open && unsavedChanges) {
            ShowModal(
            'Несохраненные изменения',
            <div>У вас есть несохраненные данные. Вы уверены, что хотите закрыть шторку?</div>,
            async () => {
                performToggle();
            }
            );
        return;
    }
    performToggle();
    };


    const getMenu = (menuRole) => {
        switch (menuRole) {
            case "admin":
                return (
                    <Menu
                        id="basic-menu"
                        // @ts-ignore
                        anchorEl={anchorSettings}
                        open={openAllSettings}
                        onClose={handleCloseSettings}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                    >
                        <MenuItem onClick={() => handleSettirngsOpen('AdminSettings')}>Настройки</MenuItem>
                        {adminMenuCheckRole("company") && <MenuItem onClick={() => handleSettirngsOpen('company')}>Компания</MenuItem>}
                        {/* <MenuItem onClick={() => handleSettirngsOpen('documents')}>Документы</MenuItem> */}
                        {/* <MenuItem onClick={() => handleSettirngsOpen('addresStorage')}>Адресное хранение</MenuItem> */}
                        {adminMenuCheckRole("handbook") && <MenuItem onClick={() => handleSettirngsOpen('handbook')}>Справочник</MenuItem>}
                        {/* <MenuItem onClick={() => handleSettirngsOpen('telephone')}>Телефония</MenuItem> */}
                        <MenuItem onClick={() => {setOpenSearch(true)}}>Поиск</MenuItem>
                        <MenuItem onClick={handleLogoutClick}>Выйти</MenuItem>
                    </Menu>
                )
            case "client":
                return (
                        <Menu
                            id="basic-menu"
                            // @ts-ignore
                            anchorEl={anchorSettings}
                            open={openAllSettings}
                            onClose={handleCloseSettings}
                            MenuListProps={{
                                'aria-labelledby': 'basic-button',
                            }}
                        >
                            {/* <MenuItem onClick={() => handleSettirngsOpen('handbook')}>Справочник</MenuItem> */}
                            {/* <MenuItem onClick={() => {setOpenEI(true)}}>Настройки</MenuItem> */}
                            {clientMenuCheckRole('ClientSettings') && <MenuItem
                                onClick={() => {
                                    setOpenSettings(true);
                                    handleCloseSettings();
                                }}
                                >Настройки</MenuItem>}
                            {clientMenuCheckRole('BarcodeSettings') && <MenuItem onClick={() => handleSettirngsOpen('BarcodeSettings')}>Настройки ШК</MenuItem>}
                            {clientMenuCheckRole('ClientWorkers') && <MenuItem onClick={() => handleSettirngsOpen('ClientWorkers')}>Сотрудники</MenuItem>}
                            {/* {clientMenuCheckRole('ClientAPISettings') && <MenuItem onClick={() => handleSettirngsOpen('ClientAPISettings')}>Интеграция по API</MenuItem>} */}
                            {/* {clientMenuCheckRole('ClientDocumentsSettings') && <MenuItem onClick={() => handleSettirngsOpen('ClientDocumentsSettings')}>Реквизиты</MenuItem>} */}
                            {clientMenuCheckRole('ClientAddAcc') && <MenuItem onClick={() => DialoghandleClickOpen()}>Добавить аккаунт</MenuItem>}
                            <MenuItem onClick={() => handleSettirngsOpen('ClientGuide')}>Обучение</MenuItem>
                            <MenuItem onClick={handleLogoutClick}>Выйти</MenuItem>
                        </Menu>
                    
                )
            default:
                <Menu
                    id="basic-menu"
                    // @ts-ignore
                    anchorEl={anchorSettings}
                    open={openAllSettings}
                    onClose={handleCloseSettings}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button',
                    }}
                >
                    {/* <CompanyClient data={comps}></CompanyClient> */}
                    {/* <MenuItem onClick={() => handleSettirngsOpen('documents')}>Документы</MenuItem> */}
                    <MenuItem onClick={handleLogoutClick}>Выйти</MenuItem>
                </Menu>
        }
    }

    return (
        <AppBar position="static" sx={{ 
            backgroundColor: '#F5F9FA',//'rgba(255, 255, 255, 0.9)', 
            // borderBottom: '2px solid #d9d9d9',
            borderStyle: {borderRadius: "10px"},
            boxShadow: 'none',
            width: "98%",
            margin: "1% 1% 5px 1%",
            borderRadius:" 10px"
        }}>
            <Dialog
                open={openSearch}
                maxWidth='lg'
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { setOpenSearch(false) }}
            >
                <div style={{ height: '620px', width: '1000px', padding: '12px', }}>
                    <GlobalSearch cancel={() => {setOpenSearch(false)}}></GlobalSearch>
                </div>

            </Dialog>
            <Box sx={{ width: '100%', padding: '0% 1% 0% 1%' }}>
                <Box sx={{ width: '100%', paddingInline: '4px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', flexFlow: 'wrap' }}>
                    <Box sx={{display: "flex", flexDirection: "row", alignItems: "center", width: ds.descr.id === 'client'? "65%": "92%"}}>
                        <Button color="inherit" onClick={homeClick} sx={{width: "5%", paddingLeft: "10px"}}>
                            <Typography variant="h3" sx={{
                                color: '#078476',
                                textDecoration: 'none',
                                fontSize: 30,
                                fontWeight: 'normal'
                            }}>
                                MFT
                            </Typography>
                        </Button>

                        <Tabs
                            ref={containerRef} 
                            value={tab}
                            onChange={handleChange}
                            // textColor="#808080"
                            indicatorColor="primary"
                            role="navigation"
                            aria-label="secondary tabs example"
                            sx={{ 
                                minHeight: '30px', 
                                height: "30px",
                                "& .MuiTabs-scrollButtons": {
                                    width: 32,
                                    height: 32,
                                    borderRadius: '50%',
                                    transition: 'all 0.2s ease-in-out',
                                    color: '#078476',
                                    '&.Mui-disabled': {
                                        opacity: 0.0
                                    },
                                    '&:hover': {
                                        backgroundColor: 'rgba(7, 132, 118, 0.12)', // лёгкая подсветка
                                        transform: 'scale(1.08)',                  // небольшое увеличение
                                        boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                                        color: '#066b60',
                                    },
                                    '&:active': {
                                        transform: 'scale(0.96)', // эффект нажатия
                                    },
                                },
                            }}
                            variant="scrollable"
                            scrollButtons={true}
                            allowScrollButtonsMobile
                            TabIndicatorProps={{
                                style: { height: '2.5px' }
                            }}
                            
                        >
                            {ds.descr.items.map((el) =>
                                {
                                    return (
                                        checkRole(el.id) && 
                                        <HEADERTab 
                                            label={el.title} 
                                            key={el.id} 
                                            id={el.id} 
                                            value={el.id} 
                                            // iconPosition="start" 
                                            sx={{ 
                                                textTransform: 'capitalize', 
                                                fontFamily: 'primary', 
                                            }} 
                                            onClick={(e) => {handleChange(e, el.id)}} 
                                                // icon={
                                                //     <span onClick={(e) => {
                                                //         e.stopPropagation(); // Предотвращаем всплытие события
                                                //         handleChange(e, el.id); // Вызываем обработчик с нужным ID
                                                //     }}>
                                                //         <IconTab img={el.icon}/>
                                                //     </span>
                                                // }
                                        />
                                    )
                                }
                            )}
                        </Tabs>
                    </Box>
                    <Box sx={{ 
                        display: 'flex', 
                        flexDirection: 'row', 
                        justifyContent: 'flex-end', 
                        alignItems: 'center',
                        width: ds.descr.id === 'client'? "35%": "8%"
                        }}
                    >
                        {ds.descr.id === 'admin'
                            ?
                                <IconButton sx={{ margin: "1%" }}>
                                    <UserAvatar src={userPhoto} userData={user} user_id={user_id} size={45} marginRight="0px"/>
                                </IconButton>
                            : 
                                <div style={{ display: 'flex', alignItems: 'center',}}>
                                    <CliUrInfo userPhoto={userPhoto} user={user} user_id={user_id}></CliUrInfo>
                                </div>

                        }
                        {/*  выпадающий выбор маркетов (только для клиента) */}
                        {ds.descr.id === 'client' && 
                            <SelectMarket markets={['custom', 'wb', 'ozon']} user_id={user_id}></SelectMarket>
                        } 
                        <div style={{marginLeft: "10px"}}>
                            <Tooltip title="Меню">
                                <IconButton sx={{ p: 0}} onClick={openMenuSettigs} aria-describedby={idSettings}>
                                    <img src={points} style={{ height: '34px'}}></img>
                                </IconButton>
                            </Tooltip>
                            {/* различные другие возможности для разделения ролей */}
                            {getMenu(ds.descr.id)}
                        </div>
                    </Box>
                </Box>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                    
                    {/* если на дашбордах, то поялвляется кнопка для редактирования дашбордов */}
                    {/* {location.pathname !== '/home' ? <></> : <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Typography variant="caption" color={'black'} noWrap>Редакт. виджетов</Typography>
                        <FormControlLabel label={undefined} style={{ marginLeft: 0, marginRight: 0 }}
                            control={<MaterialUISwitchEdit defaultChecked={true} onChange={handleChangeSwitchEditWidjets} />}
                        />
                    </div>
                    } */}
                </Box>
            </Box>
            <Dialog
                open={open}
                onClose={DialoghandleClose}
                PaperProps={{ sx: { borderRadius: "40px" } }}
            >
                <NewClientDialog close={DialoghandleClose} alter_cli={true}/>
            </Dialog>
            <Drawer
                anchor='right'
                open={openSettings}
                onClose={handleClose}
                >
                <ElementInfo 
                    ds={getDataSource('ClientSettings')} 
                    data={{}} 
                    // @ts-ignore
                    setChanged={setUnsavedChanges} 
                />
            </Drawer>
        </AppBar>

    );
}

function CliUrInfo( {user, user_id, userPhoto} ) {
    console.log("user", user)

    const [data, setData] = useState({name:undefined, inn:undefined, err: undefined})
    const [loading, setLoading] = useState(false)
    const [isOpen, setIsOpen] = useState(false);
    const { sub_id } = useSelector(loginSelector);
    const componentRef = useRef(null);
    const [uid, setUID] = useState(undefined)
    const [photo, setPhoto] = useState("")

    useEffect(() => {
        if (userPhoto) {
            console.log("userPhoto", userPhoto)
            setPhoto(userPhoto)
        }
    }, [userPhoto]); 


    const [linked, setLinked] = useState([])

    const fetchData = async () => {
        try {
            setLoading(true);
            const responseData = await get('UserRekv/get', {uid:user_id});
            if (responseData?.message && responseData.message.data) {
                let tmp = JSON.parse(responseData.message.data)
                if (tmp.type && tmp.name && tmp.INN) {
                    let obj = {
                        name: `${tmp.type} ${tmp.name}`,
                        inn: tmp.INN,
                        err:false
                    }
                    setData(obj)
                }
                else {
                    setData({
                        name: undefined,
                        inn: undefined,
                        err:true
                    })
                }
            }else {
                setData({
                    name: undefined,
                    inn: undefined,
                    err:true
                })
            }

            let linkedResp = undefined
            if (sub_id) {
                linkedResp = await get('auth/getLinksSub', {uid:user_id, sub_id});
            }
            else {
                linkedResp = await get('auth/getLinks', {uid:user_id});
            }
            setLinked(linkedResp)
        }
        catch {}
        finally {setLoading(false);}
    }

    useOn("updated_user_rekv", (data) => {
        if (data.user_id === user_id) {
            fetchData()
        }
    });

    useOn("new_alter_acc", (data) => {
        if (data.user_id === user_id) {
            fetchData()
        }
    });

    useEffect(() => {
        fetchData();
    }, [user_id]);

    const navigate = useNavigate()
    const dispatch = useDispatch();
    
    const changeAcc = async (seluid) => {
        // @ts-ignore
        // dispatch(seamlesAuth({uid:user_id, seluid}));
        await dispatch(seamlesAuth({ uid: user_id, seluid, sub_id: sub_id || undefined })).unwrap();
        navigate('/home')
        setIsOpen(false)
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (componentRef.current && !componentRef.current.contains(event.target) && isOpen) {
                setIsOpen(false);
            }
        };
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    if (loading) return (<Loading></Loading>)
    // @ts-ignore
    return (
        <div ref={componentRef} style={{ position: 'relative'}}>
            <Box
                onClick={() => setIsOpen(!isOpen)}
                sx={{
                    px: 1.5,
                    py: "2px",
                    borderRadius: isOpen ? "6px 6px 0 0" : "6px",
                    display: "inline-block",
                    minWidth: 350,
                    cursor: "pointer",
                    backgroundColor: isOpen ? '#F5F9FA' : "transparent",
                    // marginTop: "-10px",
                    paddingTop: "5px",
                    zIndex: 1001,
                    transition: "all 0.2s ease",
                    "&:hover": {
                        background: "#f5f5f5"
                    }
                }}
            >
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <IconButton sx={{ p: 0 }}>
                        <UserAvatar src={photo} userData={user} user_id={user_id} size={45} />
                    </IconButton>
                    <div style={{ marginLeft: "10px" }}>
                        {!data.err ? (
                            <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', float: 'left', clear: 'left' }}>
                                <span style={{ fontWeight: 'bold', color: 'black', display: 'inline-block', whiteSpace: 'nowrap', fontSize: 16 }}>
                                    {data.name}
                                </span>
                                <div style={{display: 'flex', flexDirection: 'row', justifyContent: "space-between", alignItems: 'center'}}>
                                    <span style={{ fontWeight: 'normal', color: colors.font_second, fontSize: 14, display: 'inline-block', whiteSpace: 'nowrap' }}>
                                        {`ИНН: ${data.inn}`}
                                    </span>
                                    {isOpen ? <KeyboardArrowUpIcon style={{color:'black', marginRight: "-4px"}}/> : <KeyboardArrowDownIcon style={{color:'black', marginRight: "-4px"}}/>}
                                </div>

                            </div>
                        ) : (
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <Typography variant="body1" color={"black"}>Пожалуйста, укажите данные</Typography>
                            </div>
                        )}
                    </div>
                </div>
            </Box>

            <div style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                zIndex: 1000,
                marginTop: '-5px',
                backgroundColor: '#F5F9FA',//'white',
                borderRadius: '0 0 6px 6px',
                // boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                padding: '10px',
                transition: 'all 0.3s ease',
                opacity: isOpen ? 1 : 0,
                transform: isOpen ? 'translateY(0)' : 'translateY(-12px)',
                pointerEvents: isOpen ? 'auto' : 'none',
                visibility: isOpen ? 'visible' : 'hidden',
                height: "180px",
                boxSizing: 'border-box',
                overflow: 'hidden'
            }}>
                {isOpen && (
                    <Scrollbars style={{ height: "100%" }} autoHide renderTrackHorizontal={props => <div {...props} style={{ display: "none" }}/>}>
                        {linked.map((link) => (
                            <Box
                                key={link.id}
                                sx={{
                                    px: 1.5,
                                    py: "2px",
                                    borderRadius: "6px",
                                    display: "block",
                                    // minWidth: 80,
                                    textAlign: "center",
                                    cursor: "pointer",
                                    // width: "99%",
                                    // marginLeft: "1%",
                                    "&:hover": {
                                        background: "#f5f5f5"
                                    }
                                }}
                                onClick={() => changeAcc(link.id)}
                            >
                                <Tooltip 
                                    title={link.rekv ? `${link.rekv.type} ${link.rekv.name}`   : link.fio}    
                                >
                                    <Box sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        flexDirection: 'row',
                                        borderRadius: "10px",
                                        transition: "0.2s",
                                        height: 44,
                                        color: "#838383",
                                        fontSize: '16pt',
                                    }}>
                                        <UserAvatar src={link.data.photo || ""} userData={link} user_id={link.id} size={40} />
                                        <div style={{ display: 'flex', justifyContent: 'flex-start', flexDirection: 'column', marginLeft: "10px", alignItems: 'flex-start'}}>
                                            <Typography style={{ fontWeight: 'bold', color: 'black', display: 'inline-block', whiteSpace: 'nowrap', fontSize: 16 }}>
                                                {link.rekv ? `${link.rekv.type} ${link.rekv.name}`   : link.fio}
                                            </Typography>
                                            <Typography style={{ fontWeight: 'normal', color: colors.font_second, fontSize: 14, display: 'inline-block', whiteSpace: 'nowrap' }}>
                                                {link.rekv ? `ИНН: ${link.rekv.INN || 'не указан'}` : `Реквизиты не указаны`}
                                            </Typography>
                                        </div>
                                    </Box>
                                </Tooltip>
                            </Box>
                        ))}
                    </Scrollbars>
                )}
            </div>
        </div>
    );
}

export default MainHeader;